import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetPostJobsDetailQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetPostJobsDetailQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', productionJobId: string, productionLotId: string, parentProductionJobId?: string | null, productionCatalogId: string, productionCategoryId: string, productionItemId?: string | null, jobNumber: number, productionPlanName: string, customerName?: string | null, genus: string, series: string, color: string, categoryName: string, locationId?: string | null, locationName?: string | null, quantity: number, eaches: number, unitLabel: string, yield: number, postingStatus: Types.JobPostingStatus, lotClosedStatus: Types.LotClosedStatus, producedLocationId?: string | null, postedQuantity: number, unpostedProducedQuantity: number, unpostedQuantity: number, producedQuantitySource: Types.ProducedQuantitySource, producedLocations: Array<{ __typename?: 'ProducedLocationQuantity', locationId: string, quantity: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type PostJobsJobDetailFragment = { __typename?: 'ProductionJobDocument', productionJobId: string, productionLotId: string, parentProductionJobId?: string | null, productionCatalogId: string, productionCategoryId: string, productionItemId?: string | null, jobNumber: number, productionPlanName: string, customerName?: string | null, genus: string, series: string, color: string, categoryName: string, locationId?: string | null, locationName?: string | null, quantity: number, eaches: number, unitLabel: string, yield: number, postingStatus: Types.JobPostingStatus, lotClosedStatus: Types.LotClosedStatus, producedLocationId?: string | null, postedQuantity: number, unpostedProducedQuantity: number, unpostedQuantity: number, producedQuantitySource: Types.ProducedQuantitySource, producedLocations: Array<{ __typename?: 'ProducedLocationQuantity', locationId: string, quantity: number }> };

export type GetProductionJobAdjustmentDetailQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetProductionJobAdjustmentDetailQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', productionJobId: string, productionLotId: string, jobNumber: number, postingStatus: Types.JobPostingStatus, lotClosedStatus: Types.LotClosedStatus, postedProductionLines: Array<{ __typename?: 'ProductionJobPostedLineDocument', grade: number, producedLocationId: string, quantity: number }>, postedAdjustments: Array<{ __typename?: 'ProductionJobAdjustmentDocument', adjustmentId: string, grade: number, producedLocationId: string, delta: number, reason: Types.ProductionAdjustmentReason, note?: string | null, resultingSlotQuantity: number, appliedWhileClosed: boolean, adjustedAt: Types.TDateISO, adjustedBy: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ProductionJobAdjustmentDetailFragment = { __typename?: 'ProductionJobDocument', productionJobId: string, productionLotId: string, jobNumber: number, postingStatus: Types.JobPostingStatus, lotClosedStatus: Types.LotClosedStatus, postedProductionLines: Array<{ __typename?: 'ProductionJobPostedLineDocument', grade: number, producedLocationId: string, quantity: number }>, postedAdjustments: Array<{ __typename?: 'ProductionJobAdjustmentDocument', adjustmentId: string, grade: number, producedLocationId: string, delta: number, reason: Types.ProductionAdjustmentReason, note?: string | null, resultingSlotQuantity: number, appliedWhileClosed: boolean, adjustedAt: Types.TDateISO, adjustedBy: string }> };

export type ProductionLotPostingLifecycleFragment = { __typename?: 'ProductionLotStateData', productionLotId: string, closedStatus: Types.LotClosedStatus, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, postingStatus: Types.JobPostingStatus } };

export type GetPostJobsConsumptionManifestQueryVariables = Types.Exact<{
  jobs: Array<Types.ProductionJobConsumptionRequestInput> | Types.ProductionJobConsumptionRequestInput;
}>;


export type GetPostJobsConsumptionManifestQuery = { __typename?: 'Query', productionJobConsumptionManifest: { __typename?: 'ProductionJobConsumptionManifest', hasAnyShortage: boolean, jobs: Array<{ __typename?: 'ProductionJobConsumptionManifestJob', productionJobId: string, producedQuantity: number, rows: Array<{ __typename?: 'ProductionJobConsumptionManifestRow', materialItemId: string, materialItemName: string, materialItemCategory: string, multiple: number, computedQuantity: number, locationId: string, siteLocationId: string, onHandAvailable: number, hasShortage: boolean }> }> } };

export type GetProductionJobPostingStagesQueryVariables = Types.Exact<{
  jobs: Array<Types.ProductionJobPostingStagesJobInput> | Types.ProductionJobPostingStagesJobInput;
}>;


export type GetProductionJobPostingStagesQuery = { __typename?: 'Query', productionJobPostingStages: Array<{ __typename?: 'ProductionJobPostingStages', productionLotId: string, productionJobId: string, reservationPeg: Types.ProductionPostingStageStatus, hardgoodsConsumed: boolean, lastPostingAttemptKey?: string | null }> };

export const PostJobsJobDetailFragmentDoc = new TypedDocumentString(`
    fragment PostJobsJobDetail on ProductionJobDocument {
  productionJobId
  productionLotId
  parentProductionJobId
  productionCatalogId
  productionCategoryId
  productionItemId
  jobNumber
  productionPlanName
  customerName
  genus
  series
  color
  categoryName
  locationId
  locationName
  quantity
  eaches
  unitLabel
  yield
  postingStatus
  lotClosedStatus
  producedLocationId
  producedLocations {
    locationId
    quantity
  }
  postedQuantity
  unpostedProducedQuantity
  unpostedQuantity
  producedQuantitySource
}
    `, {"fragmentName":"PostJobsJobDetail"});
export const ProductionJobAdjustmentDetailFragmentDoc = new TypedDocumentString(`
    fragment ProductionJobAdjustmentDetail on ProductionJobDocument {
  productionJobId
  productionLotId
  jobNumber
  postingStatus
  lotClosedStatus
  postedProductionLines {
    grade
    producedLocationId
    quantity
  }
  postedAdjustments {
    adjustmentId
    grade
    producedLocationId
    delta
    reason
    note
    resultingSlotQuantity
    appliedWhileClosed
    adjustedAt
    adjustedBy
  }
}
    `, {"fragmentName":"ProductionJobAdjustmentDetail"});
export const ProductionLotPostingLifecycleFragmentDoc = new TypedDocumentString(`
    fragment ProductionLotPostingLifecycle on ProductionLotStateData {
  productionLotId
  closedStatus
  finishJob {
    productionJobId
    postingStatus
  }
}
    `, {"fragmentName":"ProductionLotPostingLifecycle"});
export const GetPostJobsDetailDocument = new TypedDocumentString(`
    query GetPostJobsDetail($where: ProductionJobDocumentFilterInput, $first: Int) {
  productionJobs(where: $where, first: $first) {
    nodes {
      ...PostJobsJobDetail
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PostJobsJobDetail on ProductionJobDocument {
  productionJobId
  productionLotId
  parentProductionJobId
  productionCatalogId
  productionCategoryId
  productionItemId
  jobNumber
  productionPlanName
  customerName
  genus
  series
  color
  categoryName
  locationId
  locationName
  quantity
  eaches
  unitLabel
  yield
  postingStatus
  lotClosedStatus
  producedLocationId
  producedLocations {
    locationId
    quantity
  }
  postedQuantity
  unpostedProducedQuantity
  unpostedQuantity
  producedQuantitySource
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionJobAdjustmentDetailDocument = new TypedDocumentString(`
    query GetProductionJobAdjustmentDetail($where: ProductionJobDocumentFilterInput, $first: Int) {
  productionJobs(where: $where, first: $first) {
    nodes {
      ...ProductionJobAdjustmentDetail
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionJobAdjustmentDetail on ProductionJobDocument {
  productionJobId
  productionLotId
  jobNumber
  postingStatus
  lotClosedStatus
  postedProductionLines {
    grade
    producedLocationId
    quantity
  }
  postedAdjustments {
    adjustmentId
    grade
    producedLocationId
    delta
    reason
    note
    resultingSlotQuantity
    appliedWhileClosed
    adjustedAt
    adjustedBy
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPostJobsConsumptionManifestDocument = new TypedDocumentString(`
    query GetPostJobsConsumptionManifest($jobs: [ProductionJobConsumptionRequestInput!]!) {
  productionJobConsumptionManifest(jobs: $jobs) {
    hasAnyShortage
    jobs {
      productionJobId
      producedQuantity
      rows {
        materialItemId
        materialItemName
        materialItemCategory
        multiple
        computedQuantity
        locationId
        siteLocationId
        onHandAvailable
        hasShortage
      }
    }
  }
}
    `);
export const GetProductionJobPostingStagesDocument = new TypedDocumentString(`
    query GetProductionJobPostingStages($jobs: [ProductionJobPostingStagesJobInput!]!) {
  productionJobPostingStages(jobs: $jobs) {
    productionLotId
    productionJobId
    reservationPeg
    hardgoodsConsumed
    lastPostingAttemptKey
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetPostJobsDetail: build.query<GetPostJobsDetailQuery, GetPostJobsDetailQueryVariables | void>({
      query: (variables) => ({ document: GetPostJobsDetailDocument, variables })
    }),
    GetProductionJobAdjustmentDetail: build.query<GetProductionJobAdjustmentDetailQuery, GetProductionJobAdjustmentDetailQueryVariables | void>({
      query: (variables) => ({ document: GetProductionJobAdjustmentDetailDocument, variables })
    }),
    GetPostJobsConsumptionManifest: build.query<GetPostJobsConsumptionManifestQuery, GetPostJobsConsumptionManifestQueryVariables>({
      query: (variables) => ({ document: GetPostJobsConsumptionManifestDocument, variables })
    }),
    GetProductionJobPostingStages: build.query<GetProductionJobPostingStagesQuery, GetProductionJobPostingStagesQueryVariables>({
      query: (variables) => ({ document: GetProductionJobPostingStagesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetPostJobsDetailQuery, useLazyGetPostJobsDetailQuery, useGetProductionJobAdjustmentDetailQuery, useLazyGetProductionJobAdjustmentDetailQuery, useGetPostJobsConsumptionManifestQuery, useLazyGetPostJobsConsumptionManifestQuery, useGetProductionJobPostingStagesQuery, useLazyGetProductionJobPostingStagesQuery } = injectedRtkApi;
